import { WireFileDto, WireTemplateModelDto } from '@treasury/api/channel';
import { TmHttpClient } from '@treasury/core/http';
import { WireTemplateQueryDto } from '../../types/wires';

export class WireCompanyRequests {
    static async searchTemplates(params: Partial<WireTemplateQueryDto>) {
        const http = await TmHttpClient.getInstance();
        return http.request<WireTemplateModelDto[] | null>(`wires//wireTemplateSearch`, {
            method: 'POST',
            body: params,
        });
    }

    static async approveTemplate(id: string) {
        return (await TmHttpClient.getInstance()).request(`wires/approveTemplate/${id}`, {
            method: 'POST',
        });
    }

    static async rejectTemplate(id: string) {
        return (await TmHttpClient.getInstance()).request(`wires/rejectTemplate/${id}`, {
            method: 'POST',
        });
    }

    static async removeTemplate(id: string) {
        return (await TmHttpClient.getInstance()).request(`wires/template/${id}`, {
            method: 'DELETE',
        });
    }

    static async removeFile(id: string): Promise<boolean> {
        return (await TmHttpClient.getInstance()).request(`wires/wireFile/${id}`, {
            method: 'DELETE',
        });
    }

    static async getWireFileContents(id: string): Promise<WireFileDto> {
        return (await TmHttpClient.getInstance()).request(`wires/wireFile/${id}`, {
            method: 'POST',
        });
    }

    static async getAllWireCompanies(nonDli: boolean) {
        return (await TmHttpClient.getInstance()).request(`wireCompanies/?nonDli=${!!nonDli}`, {
            method: 'GET',
        });
    }

    static async fetchTransferAccounts() {
        return (await TmHttpClient.getInstance()).request(
            `companyaccounts/GetWithProductFeature?type=&productfeaturetype=WireTransfer`,
            {
                method: 'GET',
            }
        );
    }

    static async getAllFileUploadUsers() {
        return (await TmHttpClient.getInstance()).request(`Wires/GetDomesticWireFileUploadUsers`, {
            method: 'GET',
        });
    }
}
